import React, { useEffect, useState, useMemo } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataTypeB0203, BProps } from 'store/ducks/Reportings/types';
import { columnsB0203 } from 'constants/reportColumns';

const B0203: React.FC<BProps> = ({ entityName }) => {
  const { date, is_displayed, headers } = useSelector(
    (state: RootState) => state.reportings,
  );

  const [data, setData] = useState<DataTypeB0203[]>([]);
  const memoizedColumns = useMemo(() => columnsB0203, [columnsB0203]);

  const dispatch = useDispatch();
  const fetchData = async () => {
    dispatch(set_isDisplayed(false));
    const entityIds: string[] = entityName
      ? entityName.split(',').map((id) => id.trim())
      : [];

    const params = {
      entityId: entityIds,
      date,
    };
    try {
      const fetchedData =
        await reportingOp.fetchEntityContractualArrangements(params);

      if (fetchedData && fetchedData.entities) {
        const date = fetchedData.date;
        const allEntities = Object.values(fetchedData.entities).flat();

        const formattedData = allEntities.map(
          (dataItem: any, index: number) => ({
            key: index,
            date,
            entity_name: dataItem.entity_name,
            link: dataItem.zlink,
            arrangement_reference_number: dataItem.arrangement_reference_number,
            linked_contractual_arrangement:
              dataItem.linked_contractual_arrangement,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (entityName) {
      fetchData();
    }
  }, [is_displayed]);

  return (
    <>
      <Table
        columns={columnsB0203}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default B0203;
